<template>
  <div class="main_center">

    <div class="content">
        <searchBox
                :dialogVisible.sync="moreSearchItem"
                @dialogCancle="dialogCancle"
                title="更多筛选">
            <div class="search-drawer">
                <el-form :model="form" label-position="top" ref="form">
                    <!--                  <el-form-item label="业务类型：">-->
                    <!--                      <el-select v-model="form.businessType"-->
                    <!--                                 value-key="value"-->
                    <!--                                 style="width:100%;"-->
                    <!--                                 @change="selectBusTypeClick">-->
                    <!--                          <el-option v-for="(item,index) in businessTypeNamelist"-->
                    <!--                                     :key="index"-->
                    <!--                                     :label="item.name"-->
                    <!--                                     :value="item.value">-->
                    <!--                          </el-option>-->
                    <!--                      </el-select>-->
                    <!--                  </el-form-item>-->
                    <!--                <el-form-item label="年份：">-->
                    <!--                    <el-select v-model="form.year" value-key="value" style="width:100%;"  @change="yearsChange">-->
                    <!--                        <el-option v-for="(item,index) in yearsList"-->
                    <!--                                   :key="index"-->
                    <!--                                   :label="item"-->
                    <!--                                   :value="item"></el-option>-->
                    <!--                    </el-select>-->
                    <!--                </el-form-item>-->

                    <el-form-item label="项目名称/编号：">
                        <el-input clearable placeholder="请输入内容搜索" v-model="form.keywords"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="业务节点：">
                        <el-select clearable filterable v-model="form.datasetCode" value-key="id" >
                            <el-option label="全部" value="-1"></el-option>
                            <el-option :key="index"
                                       :label="item.nodeName"
                                       :value="item.datasetCode"
                                       v-for="(item,index) in flownodesListData"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="备案状态：">
                        <el-select clearable v-model="form.witnessStatus" value-key="value">
                            <el-option label="全部" value="-1"></el-option>
                            <el-option :key="index" :label="item.name" :value="item.value"
                                       v-for="(item,index) in witnessStatuslist"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="数据所属部门：">
                        <select-depart-tree
                            ref="selectDepartTreeRef"
                            :type="'2'"
                            :modelValue.sync="form.superviseDeptCodeList"
                            :isMultiple="true"
                            @handleDeptType="(val)=>changeDept(val,'5')" >
                            </select-depart-tree>
                    </el-form-item>
                </el-form>
                <div class="search-drawer__footer">
                    <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
                    <el-button @click="refresh" plain size="small">重置</el-button>
                </div>
            </div>
        </searchBox>
        <div class="search-content">
            <!-- <div class="mainBtn">
                <el-button @click="addNew()" size="small" type="primary"  v-if="hasBtnPermission('bidWitness_btn_add')">新增开评标监管记录</el-button>
                <el-button @click="deleteSelectItem()" size="small" v-if="hasBtnPermission('bidWitness_btn_list_del')">删除</el-button>
            </div> -->
            <div class="pageTitle" style="margin-top:-9px;">项目备案监管</div>
            <div class="centerSearch">

                <!-- <span class="label-form">项目名称/编号：</span> -->
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入项目名称/编号" style="width: 500px;" v-model="form.keywords">
                </el-input>
                <el-button @click="searchBtn" class="rightSearchBtn" size="small"  type="primary">搜索</el-button>
                <el-button @click="moreSearchItem = true" class="height_four" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
            </div>

        </div>
    </div>
    <div class="tableContent_">
        <div class="mainBtn">
                <el-button @click="addNew()" size="small" type="primary"  v-if="hasBtnPermission('bidWitness_btn_add')">新增开评标监管记录</el-button>
                <el-button @click="deleteSelectItem()" size="small" v-if="hasBtnPermission('bidWitness_btn_list_del')">删除</el-button>
         </div>
      <el-table class="table-content"
                :data="tableData"
                @sort-change="sortChange"
                @filter-change="filterChange"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                v-loading="dataListLoading" ref="multipleTable"
                :height="tableMaxHeight" stripe border
                @selection-change="handleSelectionChange"
                row-key="id"
                >
          <el-table-column  fixed
                            type="selection"
                            v-if="hasBtnPermission('bidWitness_btn_list_del')"
                            align="center"
                            :reserve-selection="true"
                            >
          </el-table-column>
          <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
          <el-table-column label="备案状态" prop='witnessStatusName' align="center" width='100'
                           :show-overflow-tooltip='true'>
              <template slot-scope="scope" >
                  <i :class="formatterStatusClass(scope.row.witnessStatus)"></i>
                  <span>{{scope.row.witnessStatusName}}</span>
              </template>
          </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small"  @click="router(scope.row)">{{scope.row.witnessStatus == '1'?'备案':'查看'}}</el-button>
            <el-button type="text" size="small" title="删除" v-if="hasBtnPermission('bidWitness_btn_list_del')" @click="deleteById(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column label="招标项目/标段编号" prop='businessCode' align="left" min-width='160'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="招标项目/标段名称" prop='businessName'  align="left" min-width='200'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="项目/标段" prop='groupMarkName' header-align="center" align="center" min-width='86'
                         :show-overflow-tooltip='true'>
            <template slot-scope="scope" >
                <el-tag :type="scope.row.groupMark==2?'success':''"  size="small" :hit="false" effect="plain"  > {{scope.row.groupMarkName}}</el-tag>
            </template>
        </el-table-column>
          <el-table-column label="招标人" prop='tendererName' align="left" min-width='100'
                           :show-overflow-tooltip='true'></el-table-column>
          <el-table-column label="招标代理" prop='tenderAgencyName'  align="left" min-width='100'
                           :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="业务节点" prop='flowName' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true' :filters="flownodesListDatafilter"></el-table-column>
        <el-table-column label="提交时间" prop='processinstancecreatedate'
                         header-align="center" align="center"
                         :sortable="true"
                         min-width='150'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="监管备案时间" prop='processinstanceEndDate'
                         header-align="center"
                         align="center"
                         min-width='150'
                         :sortable="true"
                         :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"
                     style="padding-bottom:12px;"
                     ></el-pagination>
       </div>
  </div>
</template>

<script>
    import {nearSixYearsList} from '@/utils/index';
    import selectDepartTree from "@/views/modules/components/selectDepartTree"
    import { mapState } from "vuex";
    export default {
    name: "busWitnessTable",
    components:{
        "select-depart-tree":selectDepartTree
    },
    
    data(){
      return {
          tableMaxHeight: document.documentElement.clientHeight - 227 ,
          dataListLoading: false,
          yearsList:[],
          businessTypeNamelist:[],
          form: {
              businessType:'GC',
              keywords:'',
              tradeId:'',
              year:new Date().getFullYear(),
              businessCode:"",
              businessName:"",
              witnessMod: "-1",
              witnessStatus:"-1",
              importantPrj:-1,
              datasetCode:"-1",
              flowName:'',
              superviseDeptCodeList:[],//数据所属部门
          },
          sortParams: {
              order:'',
              prop:''
          },
        businessType:'',
        groupMark:'',
        witnessModlist: [],
        witnessStatuslist: [],
        flownodesListData:[],
        flownodesListDatafilter:[],
        moreSearchItem: false,
        checkList1: '',
        pageSize: 10,//每页条数
        pageIndex: 1,//当前页
        total: 0,//总条数
        tableData: [],
        multipleSelection: [],
        user: '', //角色类型
        formData: {},
        datasetCode:'',
      }
    },
    props:{

    },
    filters:{
      ellipsis(text, num) {
        if (text.length > num) {
          return text.substring(0, num) + '...';
        } else {
          return text;
        }
      },

    },
    activated(){

        this.form.businessType = this.$route.params.type?this.$route.params.type:"GC";
        window.sessionStorage.setItem("witnessFlowbusinessType",this.form.businessType)
        // this.refresh();
        this.getDataList()


    },
    watch:{
        uerdefultOptionCode:{
        handler (val,oldVal){
           console.log(val,oldVal,"val,oldVal")
          if(val.length!==0){this.getDataList()}
        }
    }
  },

    created(){
      this.$store.dispatch("dataDictionary/getTradingCenterOption"); //获取交易中心下拉选项
        this.getDic('jg_record_status');
        this.getDic('jz_dgwitness_bustype');
        this.yearsList = nearSixYearsList(this.form.year);
        this.getFlownodesList();
    },
    computed:{
      ...mapState({
        tradingCenterOption: state => {return state.dataDictionary.tradingCenterOption;},
        uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
    },
    mounted() {

        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if(resizeTag) { //防抖动
                that.ifmove();
                    resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    methods:{
        changeDept(val,str){//切换部门
            this.form.superviseDeptCodeList=[]
                   if(str==='5'){
                    // 多选
                     val.forEach((item,index)=>{
                        if( item.type!=="region"){
                           this.form.superviseDeptCodeList.push(item.code)
                        }
                    })
                    }
        },
        filterChange(filters) {
      let filtersParams = {};
      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach(item => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      if(filtersParams['datasetCode']){
       this.datasetCode= ''+filtersParams['datasetCode']
      }
      this.getDataList();
    },
        dialogCancle(){
            this.moreSearchItem = false
        },
        sortChange(column, prop, order){
            this.sortParams.prop = prop || column.prop;
            this.sortParams.order = order || column.order;
            this.getDataList();
        },
        formatterStatusClass(historyId){
            switch(historyId){
                case 2: return 'icon-point icon-point-success'; break;
                case 1: return 'icon-point icon-point-verificationing'; break;
                case 3: return 'icon-point icon-point-info'; break;
                case 4: return 'icon-point icon-point-verificationing'; break;
                default:return ''; break;
            }
        },
        addNew(){
            removeTabHandle('busWitness_add')
            this.$router.push({
                name:'busWitness_add',
            })
        },
        ifmove() {

             // let hasBtnPermisson = this.hasBtnPermission("bidWitness_btn_add");
             // let tableMaxHeight = document.documentElement.clientHeight - 357 +  (hasBtnPermisson ? 0 : 41);
             let tableMaxHeight = document.documentElement.clientHeight - 227;
             this.pageSize = parseInt((tableMaxHeight) / 50 ) || 1;
             this.$nextTick(() => {
                 this.tableMaxHeight = tableMaxHeight
             })
            // this.getDataList()
           
        },
        selectBusTypeClick(){
            this.getDataList()
        },
        yearsChange(val){
            this.yearsList = nearSixYearsList(val)
            this.getDataList()
        },
        getDataList() { // 获取列表数据
         this.form.superviseDeptCodeList= (this.form.superviseDeptCodeList || []).length==0?this.uerdefultOptionCode:this.form.superviseDeptCodeList
          this.dataListLoading=true;
          this.$httpReq.post('/businessFlowWitness/list', {
            'page': this.pageIndex,
            'rows': this.pageSize,
            'searchKey': this.form.keywords,
            'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
            'filter': {
                // auditYear:this.form.year,
                witnessMod: this.form.witnessMod == "-1" ? "" : this.form.witnessMod,
                importantPrj: this.form.importantPrj == -1? "" : this.form.importantPrj,
                witnessStatus: this.form.witnessStatus == "-1" ? ""  : this.form.witnessStatus,
                // datasetCode: this.form.datasetCode == "-1" ? ""  : this.form.datasetCode,
                datasetCode: this.datasetCode,
                businessName:this.form.businessName,
                businessCode:this.form.businessCode,
                businessType:this.form.businessType,
                flowName: this.form.flowName,
                superviseDeptCodeList:this.form.superviseDeptCodeList||[]
            }
          }).then(res => {
            this.tableData = res.data.rows;
            this.total = res.data.total;
            this.$refs.multipleTable.doLayout();
            this.dataListLoading = false;
          })
      },
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1
            this.getDataList()
        },
        currentChangeHandle (val) {
            this.pageIndex = val
            this.getDataList()

        },

        getDic(type) { // 获取字典
        this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
          if (res.data.code === '1') {
            switch (type) {
                case 'jg_record_status':this.witnessStatuslist = res.data.data;break;
                case 'jz_dgwitness_bustype':this.businessTypeNamelist = res.data.data;break;
            }
          }
        })
      },


        indexMethod(index) {
           return (this.pageIndex - 1) * this.pageSize + index + 1
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        //搜索按钮
        searchBtn(){
            this.pageIndex=1;
            this.moreSearchItem = false;
            this.getDataList();
        },
        refresh() {//刷新按钮
              this.pageIndex = 1;
              this.moreSearchItem = false;
              this.form.keywords = "";
              this.form.datasetCode = "-1";
              this.form.witnessStatus = "-1";
              this.form.superviseDeptCodeList=this.uerdefultOptionCode
                 // 重置默认所属数据
              if( this.$refs.selectDepartTreeRef){
                this.$refs.selectDepartTreeRef.getUserTreeOption()
              }
              this.getDataList()
        },

        getFlownodesList() {//业务节点下拉框
             this.$httpReq.post('/configs/sysFlowNodeConfig/list', {
                 'page': 1,
                 'rows': 200,
                 'filter': {
                     busType: this.form.businessType,
                     enableHandle:1
                 }
             }).then(res => {
                 this.flownodesListData = res.data.rows;
                 // 用于表格过滤
                 this.flownodesListDatafilter=res.data.rows;
                 this.flownodesListDatafilter.forEach((item)=>{
                        item.text=item.nodeName
                        item.value='datasetCode_'+item.datasetCode
                 })

             })
        },


      router(item){ // 跳转详情

          if(item.id && item.enteringType == 2){
              removeTabHandle('busWitness_add')
              this.$router.push({
                  name:'busWitness_add',
                  query:{
                      id:item.id,
                      processinstanceid:item.processinstanceid,
                      witnessStatus:item.witnessStatus,

                  }
              })
              return
          }
          var id = item.id;
          removeTabHandle('busWitness_detail');
          this.$router.push({
            name:'busWitness_detail',
            query:{
                id:id,
                businessType:item.businessType || this.form.businessType,
                purchaserMode:item.purchaserMode || ''
            }
          })

      },



      deleteById(item) {
        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$httpReq.get('/businessFlowWitness/delete?id='+item.id+"&entityId="+item.entityId, /*{
            id: item.id,
            entityId: item.entityId
          }*/).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      deleteSelectItem() {
        let ids = new Array();
        let entityIds = new Array();
        this.multipleSelection.forEach(key => {
          ids.push(key.id),
              entityIds.push(key.entityId)
        })

        if (ids != "" || ids.length > 0) {
          this.$httpReq.get('/businessFlowWitness/delete?idList='+ids+"&entityIdList="+entityIds, /*{
            idList: ids,
            entityIdList: entityIds
          }*/).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: "未选择删除项。"
          })
        }

      },
    },

    destroyed(){
      window.onresize = null;
    },




}
</script>
<style lang="scss">
.content{
    .centerSearch{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .rightSearchBtn{
        height:40px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .height_four{
        height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
}
</style>
<style lang="scss" scoped>
.mainBtn{
    padding:16px;
}
.content{
    .centerSearch{
    width: calc(100% - 162px);
    height:40px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    }

.search-content {
    padding: 24px;
    display: flex;
	align-items: center;
   .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
    }
    
  }
  .search-content > div{
     line-height: normal;
     padding:0;
  }

}

</style>
